import React, { useEffect } from "react";
import dayjs from "dayjs";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Typography,
  Divider,
  RadioGroup,
  Radio,
  FormControlLabel,
  MenuItem,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import {
  ClearRounded,
  CloudUploadRounded,
  DeleteRounded,
  SaveRounded,
} from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAfterSchool,
  updateAfterSchool,
  updateAfterSchoolField,
} from "../../../redux/actions/adminActions";
import {
  uploadBoardFile,
  uploadBoardImage,
} from "../../../redux/actions/managerActions";

export default function AdminEditAfterSchool({
  editOpen,
  setEditOpen,
  info,
  setInfo,
  initial,
  type = null,
  afterSchoolInfo = null,
}) {
  const { url } = useSelector((state) => state.manager);
  const dispatch = useDispatch();

  const handleClose = () => {
    setEditOpen(false);
    setInfo(initial);
  };
  const onChange = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value });
  };
  const onChangeDate = (e) => {
    setInfo({
      ...info,
      [e.target.name]: dayjs(e.target.value).format("YYYY-MM-DD"),
    });
  };
  const handleSaveInfo = () => {
    // console.log("endDay=>", info.endDay);
    // save
    if (
      info.name === "" ||
      info.userId === "" ||
      info.startDay === "" ||
      info.startDay === "Invalid Date" ||
      info.endDay === "" ||
      info.endDay === "Invalid Date" ||
      info.phone === ""
    ) {
      alert("필수정보를 입력하시기 바랍니다.");
    } else if (dayjs(info.startDay) > dayjs(info.endDay)) {
      alert("종료일은 시작일보다 이후 날짜여야 합니다.");
    } else {
      const conf = window.confirm("수정하시겠습니까?");
      // console.log("Edit =>", info);
      if (conf) {
        dispatch(updateAfterSchool(info));
        setEditOpen(false);
      }
    }
  };
  const handleDeleteInfo = () => {
    const conf = window.confirm(
      "삭제하시겠습니까? 회원Level은 8에서 일반고객(9)으로 전환되며, 해당 리스트에서는 다시는 볼 수 없습니다."
    );
    if (conf) {
      dispatch(deleteAfterSchool(info?.afterSchoolId));
      setEditOpen(false);
    }
  };
  const handleFile = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };
  const handleFileChange = (e) => {
    const image = e.target.files[0];
    const fileName = image.name;
    const extension = fileName.split(".").pop().toLowerCase();
    // send to the server
    const formData = new FormData(); // FormData()를 이용하여 전송
    formData.append("image", image, "/certifications/" + image.name);
    handleUploadImage(formData, extension);
  };

  const handleUploadImage = (formData, extension) => {
    if (url) {
      if (extension === "pdf") {
        dispatch(uploadBoardFile(formData));
      } else {
        dispatch(uploadBoardImage(formData));
      }
    }
  };
  useEffect(() => {
    if (url) {
      setInfo({ ...info, certificationFile: url.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]); //set

  const handleDeleteField = (field) => {
    const conf = window.confirm("정말 삭제하시겠습니까?");
    if (conf) {
      dispatch(
        updateAfterSchoolField({
          afterSchoolId: info.afterSchoolId,
          [field]: "",
        })
      );
      setInfo({ ...info, [field]: "" });
    }
  };

  return (
    <Dialog open={editOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h4">
          {type === "certificate"
            ? "자격증 수강자 정보 변경"
            : "방과후교사 정보 수정"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TextFieldWithLabel
          labelWidth="150px"
          label="회원ID"
          name="userId"
          value={info?.userId}
          onChange={onChange}
          disabled
        />
        <TextFieldWithLabel
          labelWidth="150px"
          label="회원Level"
          type="number"
          name="userLevel"
          disabled
          value={info?.userLevel}
          onChange={(e) => {
            setInfo({ ...info, userLevel: Number(e.target.value) });
          }}
        />
        <TextFieldWithLabel
          labelWidth="150px"
          label="휴대전화"
          subLabel="( - 포함)"
          name="phone"
          disabled
          value={info?.phone}
          onChange={onChange}
        />
        <TextFieldWithLabel
          labelWidth="150px"
          label={type === "certificate" ? "수강자이름" : "교사명"}
          subLabel="카톡아이디 => 본명"
          name="name"
          value={info?.name}
          onChange={onChange}
        />
        {type === "certificate" && (
          <TextFieldWithLabel
            labelWidth="150px"
            label="이메일"
            //subLabel="카톡아이디 => 본명"
            name="email"
            value={info?.email}
            onChange={onChange}
          />
        )}
        {/* 기타 주요정보 */}
        <Divider light style={{ marginTop: 5, marginBottom: 4 }} />

        <TextFieldWithLabel
          labelWidth="150px"
          label={type === "certificate" ? "지역/기관명" : "교실(클래스)명"}
          name="title"
          value={info?.title}
          onChange={onChange}
          InputProps={{
            endAdornment: info?.title && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => handleDeleteField("title")}
                >
                  <ClearRounded />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {type === "certificate" ? (
          <CertificateTitle {...{ info, setInfo, afterSchoolInfo }} />
        ) : (
          <TypeRadio {...{ info, setInfo }} />
        )}
        <TextFieldWithLabel
          labelWidth="150px"
          label="시작일"
          name="startDay"
          value={info?.startDay}
          onChange={onChangeDate}
          type="date"
        />
        <TextFieldWithLabel
          labelWidth="150px"
          label="종료일"
          name="endDay"
          value={info?.endDay}
          onChange={onChangeDate}
          type="date"
        />
        <TextFieldWithLabel
          labelWidth="150px"
          label="메모"
          name="memo"
          value={info?.memo}
          onChange={onChange}
          multiline
          maxRows={5}
          minRows={2}
          InputProps={{
            endAdornment: info?.title && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => handleDeleteField("memo")}
                >
                  <ClearRounded />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {/* pdf파일업로드 */}
        {type === "certificate" && (
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <TextFieldWithLabel
              labelWidth="150px"
              label="수료증 파일"
              name="certificationFile"
              multiline
              maxRows={5}
              minRows={1}
              value={info?.certificationFile}
              onChange={onChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box display="flex" flexDirection="column">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={handleFile}
                      >
                        <CloudUploadRounded />
                      </IconButton>
                      <input
                        type="file"
                        id="imageInput"
                        hidden="hidden"
                        onChange={handleFileChange}
                      />
                      {info?.certificationFile && (
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteField("certificationFile")}
                        >
                          <ClearRounded />
                        </IconButton>
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}
        {/* 수료여부 */}
        {type === "certificate" && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Box sx={{ flexBasis: "150px" }}>
                <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
                  수료여부
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <RadioGroup
                  row
                  value={info?.status || "ing"}
                  name="status"
                  onChange={(e) => setInfo({ ...info, status: e.target.value })}
                >
                  <FormControlLabel
                    value="ing"
                    control={<Radio color="primary" />}
                    label="미수료"
                  />
                  <FormControlLabel
                    value="done"
                    control={<Radio color="primary" />}
                    label="수료"
                  />
                </RadioGroup>
              </Box>
            </Box>
            <Box>
              <Typography
                variant="caption"
                style={{ color: "red", fontWeight: 500 }}
              >
                * 수료증 파일은 pdf파일이나 이미지만 업로드 가능합니다. <br />
                * 수료여부가 수료로 변경되면, 수료증이 표기되며, 수강기간 중에만
                노출됩니다. <br />
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSaveInfo}
          variant="contained"
          color="primary"
          startIcon={<SaveRounded />}
        >
          수정
        </Button>
        <Button
          onClick={handleDeleteInfo}
          variant="contained"
          color="default"
          startIcon={<DeleteRounded />}
        >
          삭제
        </Button>
        <Button onClick={handleClose} variant="contained">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function TextFieldWithLabel({
  labelWidth,
  label,
  subLabel,
  type,
  value,
  name,
  onChange,
  disabled,
  multiline,
  maxRows,
  minRows,
  InputProps = null,
  children, // such as button
}) {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      style={{ width: "100%" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        style={{ flexBasis: labelWidth }}
      >
        <Typography
          display="flex"
          style={{ fontSize: "16px", fontWeight: 500 }}
        >
          {label}
        </Typography>
        {subLabel && <Typography variant="caption">{subLabel}</Typography>}
      </Box>

      <TextField
        variant="outlined" //
        color="primary"
        fullWidth
        style={{ flex: 1 }}
        size="small"
        margin="dense"
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        type={type ? type : "text"}
        multiline={multiline}
        maxRows={maxRows}
        minRows={minRows}
        InputProps={InputProps}
      />
      {children}
    </Box>
  );
}

function TypeRadio({ info, setInfo }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Box sx={{ flexBasis: "150px" }}>
        <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
          유형선택
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <RadioGroup
          row
          value={info?.type}
          onChange={(e) => setInfo({ ...info, type: e.target.value })}
        >
          <FormControlLabel value="방과후" control={<Radio />} label="방과후" />
          <FormControlLabel value="구독" control={<Radio />} label="구독" />
        </RadioGroup>
      </Box>
    </Box>
  );
}

function CertificateTitle({ info, setInfo, afterSchoolInfo }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        my: 1,
      }}
    >
      <Box sx={{ flexBasis: "150px" }}>
        <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
          차수 선택*
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <TextField
          select //
          fullWidth
          variant="outlined"
          size="small"
          margin="dense"
          helperText="*수강이 시작되면 변경하지 않는 것이 좋습니다."
          value={info?.certificateTitle || "none"}
          onChange={(e) =>
            setInfo({
              ...info,
              type: "자격증",
              certificateTitle: e.target.value,
            })
          }
        >
          <MenuItem value="none">선택하세요</MenuItem>
          {afterSchoolInfo.map((aInfo) => (
            <MenuItem key={aInfo.afterschoolVideoId} value={aInfo?.title}>
              {aInfo?.title}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
}
